import { ColDef } from 'ag-grid-enterprise';
import { LoggerService } from './../../../../services/logger.service';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TableCommunicationService } from '../../../services/table-communication.service';

@Component({
  selector: 'app-line-item-cell-renderer',
  templateUrl: './line-item.component.html',
  styleUrls: ['./line-item.component.sass']
})
export class LineItemCellRendererComponent implements ICellRendererAngularComp {

  constructor(
    private tableCommunicationService: TableCommunicationService,
    private loggerService: LoggerService,
  ) {

  }

  public params: any;

  agInit(params: any): void {
    this.params = params;
    // console.log(this.params.value);
  }

  refresh(params: any): boolean {
    return false;
  }

  getBadgeStyle(v: any): object {
    if (v.lineItemType === 'Currency' && v.id) {
      if (v.id.name === 'Coin') {
        return {'background-color': '#ffcd5d'};
      } else if (v.id.name === 'Diamond') {
        return {'background-color': '#A6DDFD'};
      } else if (v.id.name === 'USP') {
        return {'background-color': '#92ABAD'}
      }
    }
    return {'background-color': 'white'}; // Default color
  }

  getContainerStyle(): object {
    if (!this.params || !this.params.value || this.params.value.length === 0) {
      return {
        'max-height': '30px',
        'height': '30px'
      };
    }
    
    const itemCount = this.params.isNestedArray ? this.params.value.length : this.params.value.length;
    const maxVisibleItems = 4; 
    const itemHeight = 24; 
    const containerPadding = 4;
    
    const idealHeight = Math.min(itemCount, maxVisibleItems) * itemHeight + containerPadding;
    
    return {
      'max-height': `${idealHeight}px`,
      'height': itemCount <= maxVisibleItems ? `${idealHeight}px` : `${idealHeight}px`,
      'overflow-y': itemCount > maxVisibleItems ? 'auto' : 'visible'
    };
  }
}
